export default { sha: 'dbee52b819fe92d204609444e04cfd69944f5343', buildNumber: 'undefined' }
